import React from 'react';
import {Box, Button} from '@mui/material';
import PropTypes from 'prop-types';
const ItemView = props => {
  if (!props.visibility) {
    return <></>;
  }
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 5,
        backgroundColor: 'rgba(55,55,55,0.5)',
      }}
    >
      <Box
        style={{
          width: '80%',
          textAlign: 'left',
          borderRadius: '20px',
          background: 'white',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          paddingBottom: '1rem',
          paddingTop: '1rem',
          color: 'black',
        }}
      >
        <Box
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            marginTop: '0.5rem',
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
          }}
        >
          이용권 없음
        </Box>
        <Box style={{fontSize: '0.85rem'}}>
          {'이용할 수 없습니다. 이용권이 있는 선생님과 연결하세요'}
        </Box>

        <Box
          style={{
            marginTop: '1rem',
            borderTop: '1px dotted #717171',
          }}
        ></Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1rem',
          }}
        >
          <Button
            style={{
              backgroundColor: '#00C500',
              width: '95%',
              color: 'white',
              fontSize: 'calc(1rem + 0.2vw)',
              fontWeight: 'bold',
              borderRadius: '10px',
              paddingTop: '0.3rem',
              paddingBottom: '0.3rem',
            }}
            onClick={() => {
              props.completeEvent();
            }}
          >
            확인
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
ItemView.propTypes = {
  visibility: PropTypes.bool,
  completeEvent: PropTypes.func,
};
export default ItemView;
